<template>
  <div>
    <el-dialog v-dialogDrag :visible.sync="unitDialogVisible" title="添加单元" width="400px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div style="margin:10px 0px;display: flex;justify-content: space-between;">
        <el-input ref="unit" v-model.trim="unitNameToAdd" style="width:85%; margin-right: 10px;" size="small"
          placeholder="请输入新单元名称" clearable />
        <el-button type="text" icon="el-icon-plus" size="small" @click="addUnitFu">添加</el-button>
      </div>
      <div>从列表选择要添加的单元：</div>
      <el-table
        ref="multipleTable"
        :key="tabKey"
        :data="filteredUnitdList.filter(data => !unitNameToAdd || data.stageName.toLowerCase().includes(unitNameToAdd.toLowerCase()))"
        tooltip-effect="dark"
        style="width: 100%;min-height:300px"
        height="calc(100% - 70px)"
        row-key="stageId"
        border
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" reserve-selection />
        <el-table-column prop="stageName" label="单元名称" align="center" />
        <el-table-column label="操作" width="180" align="center">
          <template #default="{ row }">
            <el-button size="small" type="text" @click="delUnitFu(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="unitDialogVisible = false">取 消</el-button>
        <el-button v-preventReClick size="small" type="primary" @click="submit('unit', 1)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import folderService from "@/CommonDP/service/folder-service";
export default {
  props: {
    first: {
      type: Boolean,
      default: false
    },
    treeData: {
      type: Object,
      required: false,
      default: () => {}
    },
    data: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      unitDialogVisible: false,
      selectionData: [],
      unitNameToAdd: '',
      unitList: [],
      tabKey: 1
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    filteredUnitdList() {
      // 过滤已添加的数据
      if (!this.unitDialogVisible) return [];
      const existChildIds = this.treeData?.childrenList?.map(item => item.typeId) || [];
      const dataChildIds = this.data?.map(item => item.typeId) || [];
      return this.unitList.filter((item) => {
        if (this.first) {
          return !dataChildIds.includes(item.stageId);
        } else {
          return !existChildIds.includes(item.stageId);
        }
      });
    }
  },
  methods: {
    show() {
      this.unitNameToAdd = '';
      this.selectionData = [];
      this.unitList = [];
      this.unitDialogVisible = true;
      this.tabKey++;
      this.$nextTick(() => {
        this.$refs.unit.focus();
      });
      this.queryUnitList();
    },
    async queryUnitList() {
      const prjId = this.prjInfo.prjId;
      const res = await folderService.queryUnitList({ prjId });
      this.unitList = res.data || [];
    },
    async delUnitFu(val) {
      this.$confirm("如果单元已被使用，请不要删除，确认要删除选中的单元吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(async () => {
        await folderService.dynamicUnitDelete(val.id);
        const index = this.selectionData.findIndex(
          item => item.stageId === val.stageId
        );
        this.selectionData.splice(index, 1);
        this.$refs.multipleTable.toggleRowSelection(val, false);
        this.$message.success("删除成功");
        this.queryUnitList();
      });
    },

    async addUnitFu() {
      if (!this.unitNameToAdd) {
        this.$message.warning("单元不能为空");
        return;
      }
      const params = {
        enterpriseId: this.enterpriseId,
        prjId: this.prjInfo.prjId,
        stageName: this.unitNameToAdd
      };
      await folderService.dynamicUnitSave(params);
      this.$message.success("添加成功");
      await this.queryUnitList();
      const obj = this.filteredUnitdList.filter((ele) => ele.childName === this.childNameToAdd)[0];
      this.selectionData.push(obj);
      this.$refs.multipleTable.toggleRowSelection(obj);
    },
    submit(type, val) {
      if (!this.selectionData.length) {
        this.$warn("请勾选要添加的单元");
        return;
      }
      const data = { type, val, selectionData: this.selectionData, parentNodeData: this.treeData };
      this.$emit("callback", data);
      this.unitDialogVisible = false;
    },
    handleSelectionChange(val) {
      this.selectionData = val;
    }
  }
};
</script>

<style scoped lang="scss"></style>
